module.exports = __webpack_public_path__ + "img/powerball_icon.9a966f3b.png";